import type { Application } from '#/domain/application/Application'
import type { UserRepository } from '#/domain/user/UserRepository'

export class GetUserApplicationsUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string): Promise<Application[]> {
    return this.repository.findApplications(userId)
  }
}
